import React from 'react';
import './Breadcrumbs.css';

const getRouteSlug = (category) => category?.RouteSlug || category?.Slug || category?.Sename;
const getStockMode = (catalogKind) => {
    if (catalogKind === 'preorder') {
        return 'preorder';
    }

    if (catalogKind === 'stock' || catalogKind === 'instock' || catalogKind === 'product') {
        return 'instock';
    }

    return 'all';
};
const normalizeCategoryPath = (category, breadcrumbs, index) => {
    const routeSlug = getRouteSlug(category);

    if (routeSlug?.includes('/')) {
        return routeSlug;
    }

    return breadcrumbs
        .slice(0, index + 1)
        .map((item) => getRouteSlug(item))
        .filter(Boolean)
        .join('/');
};

const buildBreadcrumbs = (category, path = []) => {
    if (!category) {
        return path;
    }

    const nextPath = [...path, category];
    return category.Parent ? buildBreadcrumbs(category.Parent, nextPath) : nextPath.reverse();
};

const Breadcrumbs = ({ category, catalogKind = 'stock' }) => {
    const breadcrumbs = buildBreadcrumbs(category);
    const query = new URLSearchParams(window.location.search);
    const currentSort = query.get('sort');
    const stockMode = getStockMode(catalogKind);

    return (
        <div className="breadcrumbs__navigation_chain">
            <nav>
                <ol className="breadcrumb__navigation_ol">
                    {breadcrumbs.map((crumb, index) => {
                        const categoryPath = normalizeCategoryPath(crumb, breadcrumbs, index);
                        const hrefQuery = new URLSearchParams();
                        if (currentSort) {
                            hrefQuery.set('sort', currentSort);
                        }

                        if (stockMode !== 'all') {
                            hrefQuery.set('stockMode', stockMode);
                        }

                        const href = `/shopping/${categoryPath}/items${hrefQuery.toString() ? `?${hrefQuery.toString()}` : ''}`;

                        return (
                            <li key={`${getRouteSlug(crumb)}-${index}`} className="breadcrumb-item">
                                {index < breadcrumbs.length - 1 ? (
                                    <a className="crumb__item_a" href={href}>
                                        {crumb.Title}
                                    </a>
                                ) : (
                                    <span className="crumb__item_span">{crumb.Title}</span>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </nav>
        </div>
    );
};

export default Breadcrumbs;
